module.exports = __webpack_public_path__ + "static/img/medium_logo3.78e3130.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/medium_logo3.png
// module id = i184
// module chunks = 11